import React from 'react';
import { ContainerBase } from '../containers';
import { SplitColorTitle } from '@/components/common/split-color-title';
import { Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';

export const WhyClaimMagic: React.FC = () => {
	const data = [
		{
			icon: Icons.cursorClick,
			title: 'Streamlined Claim Experience',
			description: 'Sign up, access, and manage your claims with a click!',
		},
		{
			icon: Icons.security,
			title: 'Secure and Seamless',
			description: 'Manage legal documents and track progress in real-time.',
		},
		{
			icon: Icons.screencast,
			title: `Stay \n Connected`,
			description:
				'Direct access to your attorney and instant answers at your fingertips.',
		},
		{
			icon: Icons.table,
			title: 'No-Risk Engagement',
			description:
				'Start your claim with zero upfront fees, and payment only upon successful resolution.',
		},
	];
	return (
		<ContainerBase className="pt-[88px]">
			<SplitColorTitle
				blackText="Why"
				colorText="Claim Magic"
				textSize="headline-48"
				className="text-center"
			/>
			<Typography
				type="regular-20"
				className="text-center mb-9 lg:mb-20 mt-6 max-w-[750px] mx-auto"
			>
				Our platform empowers our clients to sign up, monitor, and engage with
				attorneys seamless.
			</Typography>
			<div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-8 xl:gap-4">
				{data.map(({ icon, title, description }, index) => (
					<div
						key={index}
						className="flex flex-row lg:flex-col gap-x-5 lg:gap-x-0 xl:w-[296px]"
					>
						<Icon src={icon} className="!size-10 shrink-0" />
						<div>
							<Typography
								type="custom-p"
								className="!font-semibold lg:!font-bold whitespace-pre-line leading-[120%] text-2xl lg:text-[32px]"
							>
								{title}
							</Typography>
							<Typography type="regular-16" className="mt-4 lg:mt-0">
								{description}
							</Typography>
						</div>
					</div>
				))}
			</div>
		</ContainerBase>
	);
};
